import { Typography } from "@mui/material";
import { Loading } from "src/components/utils/Loading";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ModalData } from "../../PropertyModal/PropertyModal";
import { ChartMode } from "../../Chart/chart.types";

import { ByAllHeadings } from "./1_byAllHeadings";
import { ByHeading } from "./2_byHeading";
import { ByProperties } from "./4_byProperties";
import { BySubheading } from "./3_bySubheading";

type HeadingsProps = {
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};
export const Headings = (props: HeadingsProps) => {
    const { openModal, mode } = props;
    const { scoreDetailBuilder, drilldownState } = useScoreDetailContext();

    if (scoreDetailBuilder === undefined) {
        return <Loading />;
    }

    const stateLength = drilldownState.state.length;
    if (stateLength === 0) {
        return <ByAllHeadings scoreDetailBuilder={scoreDetailBuilder} drilldownState={drilldownState} mode={mode} />;
    }

    const headingId = drilldownState.state[0].id;
    if (stateLength === 1) {
        return <ByHeading headingId={headingId} openModal={openModal} mode={mode} />;
    }

    const drilldownItem = drilldownState.state[1];
    const isSubheading = drilldownItem.type === "subheadings";
    if (isSubheading) {
        const subheadingId = drilldownItem.id;

        if (stateLength > 2) {
            const propertyId = drilldownState.state[2].id;
            return (
                <ByProperties
                    headingId={headingId}
                    subheadingId={subheadingId}
                    propertyId={propertyId}
                    openModal={openModal}
                    mode={mode}
                />
            );
        }

        return <BySubheading headingId={headingId} subheadingId={subheadingId} openModal={openModal} mode={mode} />;
    }

    const isProperty = drilldownItem.type === "properties";
    if (isProperty) {
        const propertyId = drilldownItem.id;
        return <ByProperties headingId={headingId} propertyId={propertyId} openModal={openModal} mode={mode} />;
    }

    return <Typography variant="big-bold">{"You shouldn't be here"}</Typography>;
};
